import { generateValidYearRegExp } from "../webappointment/functions/generateValidYearRegExp";

export const PHONE_NUMBER_REGEX = /^[A-Z0-9]{3}\.[A-Z0-9]{3}\.[A-Z0-9]{4}$/;
export const NUMERIC_PHONE_NUMBER_REGEX = /^[2-9][0-9]{2}\.[2-9][0-9]{2}\.[0-9]{4}$/;
export const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/;
export const NUMERIC_REGEX = /^[0-9]*$/;
export const FOUR_DIGITS = /^[0-9]{4}$/;
export const ZIP_CODE_REGEX = /^(?!00000)(\d{5}|\d{5}-\d{4})$/;  // 14345, 14345-2550, or 14345-0000 but not 00000 or 00000-1234
export const NUMBER_OR_EMPTY_REGEX = /^$|[0-9]/;
export const DATE_OF_BIRTH_REGEX = generateValidYearRegExp();